import type { ReactNode } from 'react';

/** govuk/components/panel (confirmation). */
export function Panel({ title, children, headingLevel = 1 }: { title: ReactNode; children?: ReactNode; headingLevel?: 1 | 2 }) {
  const Heading = headingLevel === 1 ? 'h1' : 'h2';
  return (
    <div className="govuk-panel govuk-panel--confirmation">
      <Heading className="govuk-panel__title" tabIndex={headingLevel === 1 ? -1 : undefined}>
        {title}
      </Heading>
      {children !== undefined && <div className="govuk-panel__body">{children}</div>}
    </div>
  );
}
